import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "@fontsource/barlow-condensed/latin-700.css";
import "@fontsource/barlow-condensed/latin-ext-700.css";
import "@fontsource/atkinson-hyperlegible/latin-400.css";
import "@fontsource/atkinson-hyperlegible/latin-ext-400.css";
import "@fontsource/atkinson-hyperlegible/latin-700.css";
import "@fontsource/atkinson-hyperlegible/latin-ext-700.css";
import { App } from "./App";
import { ScaledStage } from "./components/ScaledStage";
import "./styles.css";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <ScaledStage>
      <App />
    </ScaledStage>
  </StrictMode>,
);
